import { ApplicationAddendum } from "../types/LeaseDomainAddendum";

// Addenda are submitted once per application, so any Completed addendum means nothing is
// left to answer for anyone.
export const indexPendingAddendumsByApplicantId = (
  addendumCatalog: ApplicationAddendum[]
): Record<string, ApplicationAddendum[]> => {
  const index: Record<string, ApplicationAddendum[]> = {};
  if (addendumCatalog.some((addendum) => addendum.status === "Completed")) {
    return index;
  }
  for (const addendum of addendumCatalog) {
    if (addendum.status !== "NotStarted") continue;
    (index[addendum.applicantId] ??= []).push(addendum);
  }
  return index;
};
